import React from "react";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";
import Notes from "../../../../components/Notes/Notes";
import useNotesQuery from "../../../../components/Notes/useNotesQuery";

const StyledContainer = styled.div`
  padding: 0.5rem 1rem 1rem;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledContentWrapper = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

interface IServiceMoreNotesPanel {
  service: TGetServicesCollectionItem;
}

const ServiceMoreNotesPanel = (props: IServiceMoreNotesPanel) => {
  const { service } = props;
  const notesQuery = useNotesQuery(service.id, "Servicios");

  return (
    <StyledContainer>
      <StyledContentWrapper>
        <Notes
          parentId={service.id}
          moduleName="Servicios"
          notesQuery={notesQuery}
        />
      </StyledContentWrapper>
    </StyledContainer>
  );
};

export default ServiceMoreNotesPanel;
